import { createReducer } from '@reduxjs/toolkit';
import * as EntityActions from './actions';
import { EntitiesState } from './types';

const initialState: EntitiesState = {
  allData: {
    count: 0,
    next: null,
    previous: null,
    results: {
      files: [],
      filters: [],
    }
  },
};

export const entitiesReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(EntityActions.saveAllData, (state, action) => {
      return { ...state, allData: action.payload };
    })
    // .addCase(EntityActions.saveAllData, (state, action) => {
    //   console.log('debug-action.payload saveAllData', action)
    //   return { ...state, allData: action.payload };
    // })
);
